module.exports = __webpack_public_path__ + "img/logo_dx.a4f7e1e8.png";